import PrefixEnum from '../prefixes'

export default Object.freeze({
    'www.make-the-change.de': PrefixEnum.DANIEL_AMINATI_MTC,
    'make-the-change.de': PrefixEnum.DANIEL_AMINATI_MTC,
    'www.make-the-change.com': PrefixEnum.DANIEL_AMINATI_MTC,
    'make-the-change.com': PrefixEnum.DANIEL_AMINATI_MTC,
})
